function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        value: {
            type: String
        },
        label: {
            type: String
        },
        toggleID: {
            type: String
        },
        initialValue: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            hours: 8,
            minutes: 0,
            period: false
        };
    },

    methods: {
        onChange: function onChange() {

            var period = this.period ? 'PM' : 'AM';

            var time = this.hours + ':' + this.minutes + ' ' + period;

            this.$emit('input', time);
        }
    },
    watch: {
        period: function period(newVal, oldVal) {
            this.onChange();
        }
    },
    computed: {
        availableHours: function availableHours() {
            return [].concat(_toConsumableArray(Array(12).keys())).map(function (k) {
                return k + 1;
            });
        },
        availableMinutes: function availableMinutes() {
            return ['00', '15', '30', '45'];
            // below returns int 0, need to save as 00
            //return [...Array(4).keys()].map((k) => {return k * 15})
        }
    },
    mounted: function mounted() {

        if (!this.value) {
            return false;
        }
        // Parse the string coming in
        var splitColon = this.value.split(':');
        var splitSpace = splitColon[1].split(' ');
        this.hours = splitColon[0];
        this.minutes = splitSpace[0];
        this.period = splitSpace[1] == 'PM' ? true : false;
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/cms/TimePicker.vue
// module id = Vw+E
// module chunks = 0 1